import clsx from 'clsx'
import update from 'immutability-helper'
import {mapValues} from 'lodash'

import React from 'react'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Fade from '@mui/material/Fade'

import {createPost} from 'helpers/command'

import Unit from './Unit'
import Points from './Points'
import Select from './Select'

const useStyles = makeStyles(propertiesStyles)

export default function AssessmentProperties ({context}) {

  const {translate, quizAssessment: assessment, mySubjects, myCourses, quizTypes} = context
  const classes = useStyles()

  async function updateProperties (properties) {
    const [updatedId] = await createPost('quiz', 'updateAssessmentProperties')({id: assessment.id, ...properties})
    if (updatedId == assessment.id) {
      const quizAssessment = update(context.quizAssessment, mapValues(properties, value => ({$set: value || ''})))
      context.setState({quizAssessment})
    }
  }

  function handleChange(name, properties) {
    properties = properties || (e => ({[name]: e.target.value}))
    return e => {
      updateProperties(properties(e))
    }
  }

  const courses = assessment.subject
    ? myCourses.filter(({course}) => course.substring(0,2) == assessment.subject)
    : myCourses

  return (
  // <Fade in={!context.quizSearch.assessment}>
    <Paper className={classes.container}>
      <div className={classes.root}>
        <Select
          className={classes.type}
          controlMargin="dense"
          id="type"
          caption={translate('type_label')}
          selectValue={assessment.type || ''}
          selectOnChange={handleChange('type', e => ({type: parseInt(e.target.value)}))}
          options={context.quizTypes}
          mapValue={o => o.id}
          mapText={o => translate(`${o.name}-label`)}
        />
        <Select
          className={classes.subject}
          controlMargin="dense"
          selectValue={assessment.subject || ''}
          selectOnChange={handleChange('subject', e => ({subject: e.target.value, course: undefined}))}
          caption={translate('subject_label')}
          options={context.mySubjects}
          mapValue={o => o.id}
          mapText={o => o.name}
        />
        <Select
          className={classes.course}
          controlMargin="dense"
          nullable
          selectValue={assessment.course || ''}
          selectOnChange={handleChange('course')}
          caption={translate('course_assessment_header')}
          options={courses}
          mapValue={o => o.course}
          mapText={o => o.courseName}
        />
        <Unit className={classes.unit} {...{context, onChange: handleChange('unit', unit => ({unit}))}} />
        <Points className={classes.points} context={context} />
      </div>
      <div className={classes.standards}>
        <Link className={clsx(classes.standardsLink, {selected: context.sectionName == 'standards'})} to={context.link({sectionName: 'standards'}, '/:languageId/:role/:page/:assessment/:action/:sectionName')}>
          {translate('standards')}
        </Link>
      </div>
    </Paper>
  // </Fade>
  )
}


function propertiesStyles(theme) {

  return {
    container: {
      marginTop: 20,
      marginBottom: 20,
      padding: '25px 15px',
      display: 'flex',
      flexDirection: 'column'
    },
    root: {
      display: 'flex',
      "& > div": {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 15,
        width: 75,
        "& > .label": {
          fontSize: '11pt',
          color: '#878ea1',
          marginBottom: 3
        },
        "& > .input": {
          display: 'flex'
        }
      }
    },
    standards: {
      paddingTop: 10,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    standardsLink: {
      textDecoration: 'none',
      color: '#1d9be5',
      fontWeight: 'bold'
    },
    type: {
      flexGrow: 1,
      marginLeft: '0 !important'
    },
    subject: {
      flexGrow: 1
    },
    course: {
      flexGrow: 2,
    },
    points: {
      width: '120px !important'
    },
    unit: {
      flexGrow: 3,
    }
  }
}
